export const GET_CLINIC_STAFF_INFO = "/clinic/get-staff-info";
export const GET_DOCTOR_STAFF_INFO = "/doctor/get-staff-info";
export const GET_DOCTOR_STAFF_LIST = "/doctor/get-staff-list";
export const UPDATE_CLINIC_STAFF_INFO = "/clinic/edit-staff-info";
export const UPDATE_DOCTOR_STAFF_INFO = "/doctor/edit-staff-info";
export const DELETE_CLINIC_STAFF = "/clinic/delete-staff";
export const DELETE_DOCTOR_STAFF = "/doctor/delete-staff";
export const ADD_CLINIC_STAFF = "/clinic/staff-addition-rev1";
export const ADD_DOCTOR_STAFF = "/doctor/staff-addition-rev1";
export const VERIFY_CLINIC_STAFF = "/clinic/staff-verification";
export const VERIFY_DOCTOR_STAFF = "/doctor/staff-verification";
